import { render, staticRenderFns } from "./Typologies.vue?vue&type=template&id=63715810&scoped=true"
import script from "./Typologies.vue?vue&type=script&lang=js"
export * from "./Typologies.vue?vue&type=script&lang=js"
import style0 from "./Typologies.vue?vue&type=style&index=0&id=63715810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63715810",
  null
  
)

export default component.exports